module.exports = __webpack_public_path__ + "img/gs-135.fb919d3a.png";